import type { ProjectStatus } from "@/modules/management/project/domain/types";

/** แท่ง progress — คู่กับ palette ສະຖານະ ໃນ ProjectTable (active=ຟ້າ, completed=ຂຽວ, on_hold=ກາງ) */
export function projectStatusProgressFillClass(status: ProjectStatus): string {
  switch (status) {
    case "active":
      return "bg-blue-600 dark:bg-blue-500";
    case "completed":
      return "bg-green-600 dark:bg-green-500";
    case "on_hold":
      return "bg-muted-foreground/55 dark:bg-muted-foreground/50";
    default:
      return "bg-primary";
  }
}

/** ສີຕົວເລກສ່ວນ % (ຖ້າຕ້ອງການຈັບຄູ່ກັບສະຖານະ) */
export function projectStatusAccentTextClass(status: ProjectStatus): string {
  switch (status) {
    case "active":
      return "text-blue-700 dark:text-blue-300";
    case "completed":
      return "text-green-700 dark:text-green-300";
    case "on_hold":
      return "text-muted-foreground";
    default:
      return "";
  }
}
